
import Cookies from "js-cookie";
import { Vue, Component } from "vue-property-decorator";
import Loading from "../../components/Loading.vue";

@Component({ components: { Loading } })
export default class Transition extends Vue {
  created() {
    this.GetToken();
  }

  /**
   * @description:获取临时token
   */
  async GetToken() {
    const { query } = this.$route;
    let res: any = await this.$http.SignUp.AccessTemp();
    if (res.Code === 1000) {
      const { accesstoken, exp } = res;
      const inFifteenMinutes = new Date(Number(new Date().getTime()) + exp * 60 * 1000);
      Cookies.set("wqToken", res.accesstoken, { expires: inFifteenMinutes, path: "/" });
      this.$router.push({
        path: "/login",
        query,
      });
    }
  }
}
